import React from 'react'
import img1 from "../Images/Work_Page/Rectangle 10.png"
import img2 from "../Images/Work_Page/Rectangle 11.png"
import img3 from "../Images/Work_Page/Rectangle 12.png"
import img4 from "../Images/Work_Page/Rectangle 14.png"
import img5 from "../Images/Work_Page/Rectangle 15.png"
import img6 from "../Images/Work_Page/Rectangle 13.png"
import { Link } from 'react-router-dom'


function Hero() {
  return (
    <>
    <div className='hero-container'>

        <div className="hero--text">

            <div className='left-text'>
                <h3 className='text1'>WE'VE GOT YOU COVERED</h3>
                <h1 className='text2'>Our Designs</h1>
                <h4 className='text3'>Are Seemless and Top Notch</h4>
            </div>

            <div className='vl'></div>

            <div className="right-text">
                <p className='bpc-small'>
                bpcdesignstudio is a design agency that majors on creating
                proficient designs for both big and small companies, we
                gather and evaluate user  requirements, in collaboration
                with product managers and engineers. Illustrating design
                ideas using storyboards, process flows and sitemaps. 
                </p>
            </div>

        </div>

        <div className="hero--image--container">
            <div className="hero-img"> 
                <Link to="/packages"> <img src={img1} alt="" /> </Link>
                <Link to="/packages"> <img src={img2} alt="" /> </Link>
                <Link to="/packages"> <img src={img3} alt="" /> </Link>
            </div>
            <div className="hero-img">
                <Link to="/packages"> <img src={img4} alt="" /> </Link>
                <Link to="/packages"> <img src={img5} alt="" /> </Link>
                <Link to="/packages"> <img src={img6} alt="" /> </Link>
            </div>

        </div>

     </div>
    </>
  )
}

export default Hero